import React from 'react';

import CasesDataGrid from './CasesDataGrid/CasesDataGrid';

const CareAdvisorDashboard = (): JSX.Element => {
  return <CasesDataGrid />;
};

export default CareAdvisorDashboard;
